import * as tslib_1 from "tslib";
import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatSort, MatTable } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { mapIds } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isEqual } from 'lodash';
import { debounceTime, filter, switchMap, tap } from 'rxjs/operators';
import { DialogEditCriteriasGroupComponent } from './components/dialogs/dialog-edit-criterias-group/dialog-edit-criterias-group.component';
import { FilterComponent } from './components/filter/filter.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { CompanyRankingMapperService } from './services/company-raking.mapper.service';
import { CompanyRankingService } from './services/company-ranking.service';
import { FilterStateManagerService } from './services/filter-sate-manager.service';
import { defaultCriteriaGroup } from './utils/default-criteria-group';
var CompanyRankingComponent = /** @class */ (function () {
    function CompanyRankingComponent(cdr, router, matDialog, route, companyRankingService, authenticationService, companyRankingMapper, filterStateManagerService, fuseTranslationLoaderService) {
        this.cdr = cdr;
        this.router = router;
        this.matDialog = matDialog;
        this.route = route;
        this.companyRankingService = companyRankingService;
        this.authenticationService = authenticationService;
        this.companyRankingMapper = companyRankingMapper;
        this.filterStateManagerService = filterStateManagerService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.isLoading = true;
        this.hasCriteriaData = false;
        this.selectedCompaniesHasChanged = false;
        this.criteriasGroups = [];
        this.companies = [];
        this.selectedCompanies = [];
        this.dataTableSource = [];
        this.displayedColumns = [];
        this.criteriaKeys = [];
        this.selectedCompaniesSelection = new SelectionModel(true, []);
        this.routeName = this.route.snapshot.routeConfig.path;
        this.isHorizontalScrollableTable = false;
        this.selectedCompaniesLimit = 4;
        this.filterHeight = 66;
        this.isPercentage = [
            'acceptedPercentage',
            'refusedPercentage',
            'completedPercentage',
            'incompletedPercentage',
            'responseOnTimePercentage',
            'solutionOnTimePercentage',
            'responseOnTimePercentageByRange',
            'solutionOnTimePercentageByRange'
        ];
        this.isTimeAverage = [
            'averageResponseTimeInDays',
            'averageCloseTimeInDays'
        ];
        this.isTimeAverageInSeconds = [
            'requestedInterval',
            'onNegotiationInterval',
            'pendingInterval',
            'scheduledInterval',
            'inProgressInterval',
            'reportedInterval',
            'responseInterval',
            'solutionInterval',
        ];
        this.autoReloadTime = 2 * 60000;
        this.sortDirection = 'desc';
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    CompanyRankingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.filterStateManagerService.getSavedData(this.filter, this.routeName)];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.companyRankingService.getCriteriasGroups()];
                    case 2:
                        _a.criteriasGroups = _b.sent();
                        if (!(!this.criteriasGroups || !this.criteriasGroups.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.createDefaultCriteriaGroup()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        this.subscribeToFilterValueChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyRankingComponent.prototype.ngAfterViewChecked = function () {
        this.setTableColumnsWidth();
    };
    CompanyRankingComponent.prototype.ngOnDestroy = function () {
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
        if (this.filter.filtersForm.invalid) {
            this.filterStateManagerService.isFilterOn = false;
            return;
        }
        this.filterStateManagerService.selectedOption = null;
        this.filterStateManagerService.setDataOnLocalStorage(this.filter, this.routeName);
    };
    CompanyRankingComponent.prototype.subscribeToFilterValueChanges = function () {
        var _this = this;
        this.filterSubscription = this.filter.filtersForm.valueChanges
            .pipe(filter(function () { return _this.filter.filtersForm.valid; }), tap(function () { return _this.isLoading = true; }), debounceTime(700), tap(function () {
            var currentWhere = _this.filterStateManagerService.toQuery(_this.filter.filtersForm.value);
            var defaultWhere = _this.filterStateManagerService.toQuery(_this.filter.defaultFilterValues);
            _this.filterStateManagerService.isFilterOn = !isEqual(currentWhere, defaultWhere);
        }), switchMap(function () { return _this.updateDataTableSource(); })).subscribe(function () {
            _this.isLoading = false;
            _this.filterStateManagerService.setDataToQueryParams(_this.filter, _this.routeName);
            setTimeout(function () { return _this.setContentHeight(); }, 0);
        });
    };
    CompanyRankingComponent.prototype.toggleCompany = function (company) {
        var alreadySelected = this.selectedCompaniesSelection.isSelected(company.id);
        var didntReachTheLimit = this.selectedCompaniesSelection.selected.length < this.selectedCompaniesLimit;
        if (!alreadySelected && didntReachTheLimit) {
            this.selectedCompaniesSelection.select(company.id);
            this.selectedCompanies.push(company);
        }
        else {
            this.selectedCompaniesSelection.deselect(company.id);
            this.selectedCompanies = this.selectedCompanies.filter(function (selectedCompany) { return selectedCompany.id !== company.id; });
        }
    };
    CompanyRankingComponent.prototype.handleOptionSelected = function (selectedOption) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        this.filterStateManagerService.selectedOption = selectedOption;
                        return [4 /*yield*/, this.updateDataTableSource()];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyRankingComponent.prototype.handleEditOption = function (option) {
        var _this = this;
        var dialogEditCriteriasGroupComponent = this.matDialog.open(DialogEditCriteriasGroupComponent, {
            panelClass: ['field-dialog-860'],
            data: {
                criteriaId: option.id,
                deletionShouldBeEnabled: this.criteriasGroups.length > 1
            }
        });
        dialogEditCriteriasGroupComponent.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!result) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.companyRankingService.getCriteriasGroups()];
                    case 1:
                        _a.criteriasGroups = _b.sent();
                        this.updateSelectedCriteriaGroup();
                        this.reload();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    CompanyRankingComponent.prototype.handleAddOption = function () {
        var _this = this;
        var dialogAddCriteriasGroupComponent = this.matDialog.open(DialogEditCriteriasGroupComponent, {
            panelClass: ['field-dialog-860']
        });
        dialogAddCriteriasGroupComponent.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!result) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.companyRankingService.getCriteriasGroups()];
                    case 1:
                        _a.criteriasGroups = _b.sent();
                        this.updateSelectedCriteriaGroup();
                        this.reload();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    CompanyRankingComponent.prototype.updateDataTableSource = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, _a, criteriaGroup, criteriasData;
            var _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        where = this.filterStateManagerService.toQuery(tslib_1.__assign({}, this.filter.filtersForm.value));
                        return [4 /*yield*/, Promise.all([
                                this.companyRankingService.getCriteriasGroupById(this.filterStateManagerService.selectedOption.id),
                                this.companyRankingService.criteriasDataByCriteriasGroupId(this.filterStateManagerService.selectedOption.id, where)
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), criteriaGroup = _a[0], criteriasData = _a[1];
                        this.dataTableSource = [];
                        (_b = this.dataTableSource).push.apply(_b, tslib_1.__spread(this.companyRankingMapper.mapToDataTable(criteriaGroup, criteriasData).sort(function (a, b) {
                            return _this.orderByTotalPointsAndName(a, b);
                        })));
                        if (!this.dataTableSource.length) {
                            return [2 /*return*/];
                        }
                        this.criteriaKeys = Object.keys(this.dataTableSource[0].criterias);
                        this.displayedColumns = tslib_1.__spread(['checkbox', 'position', 'name'], this.criteriaKeys);
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyRankingComponent.prototype.getRuleNameByCriteriaId = function (criteriaId) {
        var criterias = this.dataTableSource[0].criterias;
        return criterias[criteriaId].ruleName || '';
    };
    CompanyRankingComponent.prototype.orderByPoints = function () {
        var _a;
        var _this = this;
        this.isLoading = true;
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        this.dataTableSource.sort(function (a, b) {
            return _this.orderByTotalPointsAndName(a, b);
        });
        var sortedData = this.dataTableSource;
        this.dataTableSource = [];
        (_a = this.dataTableSource).push.apply(_a, tslib_1.__spread(sortedData));
        this.isLoading = false;
    };
    CompanyRankingComponent.prototype.compareComapanies = function (selectedCompanies) {
        this.router.navigate(['relatorios/comparar-empresas'], {
            queryParams: {
                userId: this.authenticationService.user.id,
                companies: JSON.stringify(mapIds(selectedCompanies))
            }
        });
    };
    CompanyRankingComponent.prototype.reload = function () {
        this.filter.filtersForm.updateValueAndValidity();
    };
    CompanyRankingComponent.prototype.autoRefresh = function (event) {
        var _this = this;
        if (event.checked) {
            this.intervalID = setInterval(function () { return _this.reload(); }, this.autoReloadTime);
            return;
        }
        clearInterval(this.intervalID);
    };
    CompanyRankingComponent.prototype.roundResult = function (result) {
        return (result % 1 === 0) ? result.toFixed(0) : result.toFixed(1);
    };
    CompanyRankingComponent.prototype.createDefaultCriteriaGroup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.companyRankingService.addCriteriasGroup(defaultCriteriaGroup)];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.companyRankingService.getCriteriasGroups()];
                    case 2:
                        _a.criteriasGroups = _b.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyRankingComponent.prototype.orderByTotalPointsAndName = function (a, b) {
        if (a.totalPoints === b.totalPoints) {
            return a.name.localeCompare(b.name);
        }
        else if (this.sortDirection === 'asc') {
            return a.totalPoints - b.totalPoints;
        }
        else {
            return b.totalPoints - a.totalPoints;
        }
    };
    CompanyRankingComponent.prototype.updateSelectedCriteriaGroup = function () {
        var _this = this;
        var selectedOptionHasBeenDeleted = !this.criteriasGroups.some(function (group) { return group.id === _this.filterStateManagerService.selectedOption.id; });
        if (selectedOptionHasBeenDeleted) {
            this.filterStateManagerService.selectedOption = this.criteriasGroups[0];
        }
    };
    CompanyRankingComponent.prototype.setContentHeight = function () {
        if (!this.contentElementRef) {
            return;
        }
        var totalHeight = '100vh';
        var topHeaderHeight = '64px';
        var pageHeaderHeight = '63px';
        var totalGap = '66px';
        var filterHeight = this.filter.getHeight() + 'px';
        var selectedCompaniesHeight = '110px';
        var contentHeight = "calc(" + totalHeight + " - " + topHeaderHeight + " - " + pageHeaderHeight + " - " + totalGap + " - " + filterHeight + ")";
        if (this.selectedCompanies && this.selectedCompanies.length) {
            contentHeight = "calc(" + contentHeight + " - " + selectedCompaniesHeight + ")";
        }
        this.contentElementRef.nativeElement.style.height = contentHeight;
    };
    CompanyRankingComponent.prototype.setTableColumnsWidth = function () {
        var trElement = document.querySelector('tr');
        var tableElement = document.querySelector('.company-ranking__content__table');
        if (!trElement || !tableElement) {
            return;
        }
        var trWidth = trElement.offsetWidth;
        var tableWidth = tableElement.offsetWidth;
        var newIsHorizontalScrollableTable = trWidth > tableWidth;
        if (newIsHorizontalScrollableTable !== this.isHorizontalScrollableTable) {
            this.isHorizontalScrollableTable = newIsHorizontalScrollableTable;
            this.cdr.detectChanges();
        }
    };
    CompanyRankingComponent.prototype.handleClick = function () {
        this.setContentHeight();
    };
    return CompanyRankingComponent;
}());
export { CompanyRankingComponent };
